module.exports = "<h2>No 'static' keyword</h2><div class=\"fragment\"><h4>Functions can be declared at 'package' scope</h4><h4>(No more Utility Classes!)</h4></div><h4 class=\"fragment\">Objects gain static behaviors with 'companion objects'</h4>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/04-syntax/04.pug
// module id = 326
// module chunks = 1